import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { SelectionValue, SelectOptions } from '../select';

const StatusFilterLabel = styled.span`
    font-size: 13px !important;
    font-weight: 400;
`;

export interface StatusFilterOption {
    label: string;
    value: string;
    chipLabel?: string;
}

interface StatusFilterSelectProps {
    options: StatusFilterOption[];
    value?: string | null;
    onChange: (value: string | null) => void;
    placeholder?: string;
    width?: string;
    maxHeight?: string;
}

export const StatusFilterSelect: FC<StatusFilterSelectProps> = ({
    options,
    value,
    onChange,
    placeholder = T._('Status', 'Admin'),
    width = '214px',
    maxHeight
}) => {
    const handleChange = (selection: SelectionValue<string>) => {
        if (!Array.isArray(selection)) {
            onChange(selection || null);
        }
    };

    return (
        <SelectOptions
            placeholder={placeholder}
            multiple={false}
            options={options.map((option) => ({
                label: <StatusFilterLabel>{option.label}</StatusFilterLabel>,
                value: option.value,
                chipLabel: option.chipLabel ?? option.label
            }))}
            value={value ?? null}
            onChange={handleChange}
            width={width}
            maxHeight={maxHeight}
        />
    );
};
